import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, LocPortal, MapLocKeys } from '@cm/core/localization';

const dpRoot = `Other Achievements|Edit Other Achievements|`;

const sharedLocProps: { htmlAllowed: boolean; feature: HubFeature; portal: LocPortal; shared: boolean } = {
	htmlAllowed: false,
	feature: HubFeature.CandidateAccessLoginEmcOtherAchievements,
	portal: 'CP',
	shared: false,
};
export type CPOtherAchievementsEditPage = 'CPOtherAchievementsEditSectionTitle';

export const cpOtherAchievementEditLocs: LocDefs<CPOtherAchievementsEditPage> = {
	CPOtherAchievementsEditSectionTitle: {
		...sharedLocProps,
		defaultValue: 'Edit Industry Certification',
		description: 'Title for the other achievements add section.',
		displayPath: `${dpRoot}Page section Title`,
		displayType: 'Title',
	},
};

export const LOC_KEYS = MapLocKeys<CPOtherAchievementsEditPage>(cpOtherAchievementEditLocs);
export type CPOtherAchievementsEditLocType = LocMap<CPOtherAchievementsEditPage>;
